import {RouteComponentProps} from '@reach/router'
import React from 'react'

const NotFound = (props: RouteComponentProps) => <>Siden kunne ikke findes</>

export default NotFound
